// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1g_XH","signatureButtonsRight":"ModalSign_signatureButtonsRight__3BGZU"};